import React, { useState } from "react";
import UpgradeAccountModal from "../../../../../Common/UpgradeAccountModal";
import Sidebar from "../../../../../../_legacy/Containers/Settings/sidebar";
import Loader from "../../../../../Common/Loader";
import { getIsConstantContactIntegrationAccessible } from "../../../../../../helpers/integrations";

export function Layout({ children, isLoading }) {
  const [isShowUpgradeAlertModal, setIsShowUpgradeAlertModal] = useState(
    !getIsConstantContactIntegrationAccessible(),
  );

  return (
    <div id="content">
      <UpgradeAccountModal
        notificaionType="integration"
        isShowUpgradeAlertModal={isShowUpgradeAlertModal}
        handleShowUpgradeAlertModal={({ isShowUpgradeAlertModal }) =>
          setIsShowUpgradeAlertModal(isShowUpgradeAlertModal)
        }
      />
      <div className="container-fluid content setting-wrapper">
        <Sidebar />
        <div className="memberWalletOuter relative">{children}</div>
        <Loader showLoader={isLoading} isFullWidth={true} />
      </div>
    </div>
  );
}
